export default {
  TODOS: 1,
  PIX: 2,
  BOLETO: 3,
  CARTAO: 4,
  PIX_BOLETO: 5,
  PIX_CARTAO: 6,
  BOLETO_CARTAO: 7,
};
